/*! Copyright (C) Microsoft. All rights reserved. */

export function updateFeedbackTextAreaPlaceholder(
	textArea: HTMLTextAreaElement,
	placeholder: string
): void {
	if (textArea.value.length > 0) {
		textArea.removeAttribute("placeholder");
	} else {
		textArea.setAttribute("placeholder", placeholder);
	}
}
